/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Pickup_FailedInputs */

const tr_geliver_substatus_pickup_failed = /** @type {(inputs: Geliver_Substatus_Pickup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim Alım Başarısız`)
};

const en_geliver_substatus_pickup_failed = /** @type {(inputs: Geliver_Substatus_Pickup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup Failed`)
};

const de_geliver_substatus_pickup_failed = /** @type {(inputs: Geliver_Substatus_Pickup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abholung fehlgeschlagen`)
};

const ru_geliver_substatus_pickup_failed = /** @type {(inputs: Geliver_Substatus_Pickup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забор не удался`)
};

/**
* | output |
* | --- |
* | "Pickup Failed" |
*
* @param {Geliver_Substatus_Pickup_FailedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_pickup_failed = /** @type {((inputs?: Geliver_Substatus_Pickup_FailedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Pickup_FailedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_pickup_failed(inputs)
	if (locale === "de") return de_geliver_substatus_pickup_failed(inputs)
	if (locale === "ru") return ru_geliver_substatus_pickup_failed(inputs)
	return tr_geliver_substatus_pickup_failed(inputs)
});